import React from 'react';
import { Clock, Award, DollarSign } from 'lucide-react';
import { Card, CardContent } from './ui/card';

const FeaturesSection = () => {
  const features = [
    {
      icon: <Clock className="w-12 h-12 text-red-500" />,
      title: 'Same-Day & Scheduled Service',
      description: 'We show up on time and ready to work.'
    },
    {
      icon: <Award className="w-12 h-12" style={{ color: '#FFD700' }} />,
      title: 'Experienced & Reliable',
      description: 'Every job handled with care and professionalism.'
    },
    {
      icon: <DollarSign className="w-12 h-12 text-white" />,
      title: 'Transparent Pricing',
      description: '$75/hour · 2-hour minimum · No hidden fees.'
    }
  ];

  return (
    <section className="py-20 bg-gradient-to-b from-black to-gray-900">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {features.map((feature, index) => (
            <Card 
              key={index} 
              className="scroll-animate bg-black/50 border-red-900/30 hover:border-red-500/50 transition-all duration-300 transform hover:scale-105 hover:shadow-xl hover:shadow-red-600/20"
            >
              <CardContent className="p-8 text-center">
                <div className="mb-4 flex justify-center">
                  {feature.icon}
                </div>
                <h3 className="text-xl font-bold text-white mb-3">
                  {feature.title}
                </h3>
                <p className="text-gray-400">
                  {feature.description}
                </p>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FeaturesSection;
